module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmcenter1"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("To General John Bell and Anna Hood and their descendants, living and dead, who, with dignity and grace, endured so much, for so long.")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('p', {
    staticClass: "pagebreak"
  })]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "height": "98%"
    },
    attrs: {
      "alt": "Image",
      "src": "images/fig_001.jpg"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("General John Bell Hood in a previously unpublished photograph, circa Richmond early 1864, before he left to command a corps in the Army of Tennessee.")]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('i', [_vm._v("John Bell Hood Personal Papers")])])])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30562dc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication1.vue
// module id = 69
// module chunks = 0